import { useMutation } from "@tanstack/react-query";

import { baseClient } from "@/api";
import { verifyCredentials } from "@/contexts/auth/api";
import { useAuth } from "@/contexts/auth/useAuth";
import {
  LOCAL_STORAGE_EXTERNAL_APP_KEY,
  LOCAL_STORAGE_EXTERNAL_BASE_URL_KEY,
  LOCAL_STORAGE_EXTERNAL_SCOPES_KEY,
} from "@/contexts/auth/utils";

interface Variables {
  code: string;
}

interface Response {
  access_token: string;
}

function useCreateExternalSession() {
  const { addAccount, switchAccount } = useAuth();

  const externalApp = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_EXTERNAL_APP_KEY)!,
  );
  const client_id = externalApp?.client_id;
  const client_secret = externalApp?.client_secret;
  const redirect_uri = externalApp?.redirect_uri;
  const baseURL = localStorage.getItem(LOCAL_STORAGE_EXTERNAL_BASE_URL_KEY)!;
  const scope = localStorage.getItem(LOCAL_STORAGE_EXTERNAL_SCOPES_KEY)!;
  const api = baseClient(null, baseURL);

  return useMutation({
    mutationFn: async (variables: Variables) => {
      const params = {
        client_id,
        client_secret,
        redirect_uri,
        grant_type: "authorization_code",
        scope,
        code: variables.code,
      };

      const { data } = await api.post<Response>("/oauth/token", params, {
        headers: {
          Authorization: null,
        },
      });

      const account = await verifyCredentials(data.access_token);
      addAccount(data.access_token, account, {
        client_id: params.client_id,
        client_secret: params.client_secret,
      });
      switchAccount(account);

      return data;
    },
  });
}

export { useCreateExternalSession };
